export const DB_INVALID_IDDENTIFIER = 'Invalid Mongo ID format';
export const DB_VALIDATION_ERROR = 'Validation failed';
export const DB_DUPLICATE_VALUE_ERROR = 'Duplicate value error';
export const DB_NETWORK_ERROR = 'Unable to connect to the database';
export const DB_SERVER_ERROR = 'An unexpected database error occurred.';

export const INVALID_SIGNATURE = 'Invalid signature';

export const INTERNAL_SERVER_ERROR = 'Internal Server Error';

export const AUTH_ERROR = 'Auth Error';

export const REQ_VALIDATION_ERROR = 'Invalid Request Body';

export const TENANT_ERROR = 'Tenant Error';
